import React, { useRef, useEffect } from "react";

const FloatingPointsBackground = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");

        const width = window.innerWidth * window.devicePixelRatio;
        const height = window.innerHeight * window.devicePixelRatio;


        canvas.width = width;
        canvas.height = height;

        // Generate points
        const points = Array.from({ length: 150 }, () => ({
            x: Math.random() * width,
            y: Math.random() * height,
            dx: (Math.random() - 0.5) * 4,
            dy: (Math.random() - 0.5) * 4,
        }));

        const draw = () => {
            ctx.clearRect(0, 0, width, height);

            // Draw each point
            for (let point of points) {
                point.x += point.dx * 0.1;
                point.y += point.dy * 0.1; 

                if (point.x <= 0 || point.x >= width) {
                    point.dx = -point.dx;
                }
                if (point.y <= 0 || point.y >= height) {
                    point.dy = -point.dy;
                }

                ctx.beginPath();
                ctx.arc(point.x, point.y, 2, 0, Math.PI * 5);
                ctx.fillStyle = "rgba(255, 255, 255, 0.25)"; 
                ctx.fill();
            }

            // Draw lines between points if they are close
            for (let i = 0; i < points.length; i++) {
                for (let j = i + 1; j < points.length; j++) {
                    const dx = points[i].x - points[j].x;
                    const dy = points[i].y - points[j].y;
                    const dist = Math.sqrt(dx * dx + dy * dy);
                    if (dist < 300) {
                        ctx.strokeStyle = "rgba(255, 255, 255, 0.1)";
                        ctx.beginPath();
                        ctx.moveTo(points[i].x, points[i].y);
                        ctx.lineTo(points[j].x, points[j].y);
                        ctx.stroke();
                    }
                }
            }

            requestAnimationFrame(draw);
        };

        draw();

        return () => {
            cancelAnimationFrame(draw);
        };
    }, []);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                zIndex: 0,
                pointerEvents: "none", // So it doesn't block interaction with other elements
                width: "100%", // Full width of the viewport
                height: "100%", // Full height of the viewport
            }}
        />
    );
};

export default FloatingPointsBackground;
